var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page',{attrs:{"name":"profile","padded":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"4","lg":"3"}},[_c('profile-sidebar')],1),_c('b-col',{attrs:{"md":"8","lg":"9"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }